import React from "react";
import { Container, Typography, Rating } from "@mui/material";
import Slider from "react-slick";
import FormatQuoteIcon from "@mui/icons-material/FormatQuote";
import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";

// Define ReviewItem type
interface ReviewItem {
  name: string;
  review: string;
  rating: number;
}

// Sample Reviews
const reviews: ReviewItem[] = [
  {
    name: "Lee Derks",
    review:
      "Swaptoon is a 5-star app! Love how easy it is to create holiday themed, animated pictures and greeting cards. Easily integrates with WhatsApp, Messenger, and other social apps. Recommend for this time of year 😁",
    rating: 5,
  },
  {
    name: "Juanito Cayabyab",
    review:
      "Delightful face swap app with impressive accuracy and ease of use. An instant hit among users of all ages.",
    rating: 5,
  },
  {
    name: "meri luz ruiz fernandez",
    review: "I love it. blessings and long live love ",
    rating: 4.5,
  },
  {
    name: "Nimesh Limbuwala",
    review:
      "Wow 😳😳...like this type product, it has given lots of features for stored celebration 🎉 and wonderful memories also beautiful pictures to make more beautiful 😍😍😍❤️❤️",
    rating: 5,
  },
  {
    name: "Dawood Ansari",
    review:
      "Revolutionary face swap app with seamless performance and a user-friendly interface. A must-have for photo enthusiasts.",
    rating: 5,
  },
  {
    name: "Willy",
    review:
      "Entertaining and innovative face swap app. Easy to use with impressively realistic results, perfect for social media.",
    rating: 4.7,
  },
  {
    name: "Mogaji Fawas",
    review:
      "Game-changing face swap app with intuitive design and high-quality output. Ideal for adding fun to your photos.",
    rating: 5,
  },
  {
    name: "joana dompreh",
    review:
      "Unique and enjoyable face swap app with advanced features and smooth operation. A top choice for fun photo edits.",
    rating: 4.3,
  },
];

const Review: React.FC = () => {
  // Slick carousel settings
  const settings: Record<string, unknown> = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: false,
  };

  const { ref, inView } = useInView({ triggerOnce: true, threshold: 0.3 });

  return (
    <Container className="my-5" ref={ref}>
      <div className="row align-items-center justify-content-center g-4">
        <div className="faq-illustration col-12 col-md-6 text-center">
          <motion.img
            src="/Buoyancy Images/Img_05.png"
            alt="Illustration"
            style={{ maxWidth: "100%", height: "auto", borderRadius: "16px" }}
            initial={{ opacity: 0, y: 100 }} // Start hidden and lower
            animate={inView ? { opacity: 1, y: 0 } : {}} // Animate when in view
            transition={{ duration: 0.8, ease: "easeOut" }}
            whileHover={{
              x: [0, 10, -10, 10, 0], // Moves left-right-left-right-center
              transition: {
                duration: 2.5,
                repeat: Infinity,
                ease: "easeInOut",
              },
            }}
          />
        </div>
        <div className="d-flex flex-column col-12 col-md-6">
          <Typography
            variant="h4"
            align="center"
            className="gradient-text mb-4"
            sx={{ fontWeight: 800, fontSize: { xs: "1.8rem", md: "2.3rem" } }}
          >
            Trusted By Our Users & Their Stories Speak For Us
          </Typography>
          <div
            className="glass-panel p-4 p-md-5"
            style={{ borderRadius: "24px", minHeight: "320px" }}
          >
            <Slider {...settings}>
              {reviews.map((testimonial, index) => (
                <div key={index} className="px-2 py-3 text-center">
                  <div className="d-flex justify-content-center mb-2">
                    <FormatQuoteIcon sx={{ color: "#c084fc", fontSize: "2.5rem", opacity: 0.8 }} />
                  </div>
                  <Typography
                    variant="body1"
                    sx={{ color: "#cbd5e1", fontSize: "1.05rem", lineHeight: 1.7, fontStyle: "italic", marginBottom: "15px" }}
                  >
                    "{testimonial.review}"
                  </Typography>
                  <Typography
                    variant="h6"
                    sx={{ color: "#f8fafc", fontWeight: 700, fontSize: "1.1rem" }}
                  >
                    {testimonial.name}
                  </Typography>
                  <div className="d-flex justify-content-center mt-2">
                    <Rating value={testimonial.rating} precision={0.5} readOnly sx={{ color: "#f59e0b" }} />
                  </div>
                </div>
              ))}
            </Slider>
          </div>
        </div>
      </div>
    </Container>
  );
};


export default Review;
